/**
 * KPI 总览筛选器内 trend_event_list 的默认配置（可与 pageConfig.filters[].kpiEventDataSource 合并覆盖）
 */

/** 与 pageConfig `kpiEventDataSource` 对齐 */
export interface IKpiEventDataSourceConfig {
  api?: string;
  mergeConsecutiveTrendDays?: boolean;
  excludeEventTypes?: string[];
  removeEventNumLimit?: boolean;
  filterEventDateField?: string;
  /** 日粒度短区间与趋势图对齐拉满天数，见 overviewEventDataModel */
  minTrendRangeDays?: number;
}

export const KPI_OVERVIEW_EVENT_DATA_SOURCE_DEFAULTS: IKpiEventDataSourceConfig =
  {
    api: '/api/v1/dashboard/pc/event_analysis_v2/trend_event_list',
    mergeConsecutiveTrendDays: false,
    removeEventNumLimit: true,
    filterEventDateField: 'start_time',
    excludeEventTypes: ['Holiday'],
  };
